import React from 'react';
import styled from 'styled-components';
import { GRID_METRIC_REGISTRY } from '../customizer/gridMetricRegistry';
import { useGridMetricData } from '../hooks/useGridMetricData';
import MetricWidget from './MetricWidget';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 20px;
`;

export default function MetricsGrid({ activeGridIds, filters }) {
  const { data, loading } = useGridMetricData(activeGridIds ?? [], filters);

  if (!activeGridIds || activeGridIds.length === 0) return null;

  return (
    <Grid>
      {activeGridIds.map((id) => {
        const config = GRID_METRIC_REGISTRY.find((m) => m.id === id);
        return (
          <MetricWidget
            key={id}
            config={config}
            data={data[id] ?? { chartType: 'coming_soon' }}
            loading={!!loading[id]}
          />
        );
      })}
    </Grid>
  );
}
